<template>
  <div :class="className">
    <div v-if="destination == 'location'" class="bold fs-14 mt18 mb3 ml16">
      Saved Address
    </div>
    <div v-if="listTitle.length" :class="listTitleClass">
      {{ listTitle }}
      <span
        v-if="titleRightButton.length"
        :class="titleRightButtonClass"
        @click="handleRightButtonClick"
      >
        {{ titleRightButton }}
      </span>
    </div>
    <ul>
      <li
        v-for="(item, index) in items"
        :key="index"
        :data-label="'location_' + get(item, mainTextKey, item)"
        :class="[marginClass ? marginClass : '']"
      >
        <div
          :class="[
            listItemClass,
            { 'border-tp': listType == 'savedAddresses' || index != 0 },
            {
              'border-dw':
                listType == 'savedAddresses' && index == items.length - 1,
            },
          ]"
        >
          <i v-if="commanItemIconClass" :class="commanItemIconClass"></i>
          <span
            v-if="listName == 'addresses'"
            :class="
              listType == 'savedAddressesForCart'
                ? 'reusable-addr-icons-for-cart'
                : 'reusable-addr-icons'
            "
          >
            <img
              v-if="getIconImgSrc(item)?.length"
              :src="staticImgBaseUrl + getIconImgSrc(item)"
            />
            <i
              v-else
              :class="[getIconClass(item), 'fs-24', 'color-grey-light']"
            ></i>
          </span>
          <!-- <i :class="getAddressIcon"></i> -->
          <div
            :class="[
              listType == 'savedAddressesForCart'
                ? 'lst-wrpr-cart'
                : 'lst-wrpr',
              {
                'border-tp':
                  listType != 'savedAddressesForCart' &&
                  (listType == 'savedAddresses' || index != 0),
              },
              {
                'border-dw':
                  (listType == 'savedAddressesForCart' &&
                    index != items.length - 1) ||
                  (listType == 'savedAddresses' && index == items.length - 1),
              },
            ]"
          >
            <span class="lst-desc-main" @click="onClick(item, index)">
              {{ get(item, mainTextKey, "") }}
            </span>
            <span
              v-if="subTextKey"
              className="lst-desc-sec fs-12"
              @click="onClick(item, index)"
            >
              {{ get(item, subTextKey, "") }}
            </span>
            <div
              v-if="
                !displayEditableIconMenu &&
                editableMenuItems?.length > 0 &&
                leftCornerbtn?.label
              "
              class="card-footer"
            >
              <span
                v-for="(btnItem, index) in editableMenuItems"
                :key="index"
                @click="btnItem.labelMethod(item)"
                class="color-tertiary fs-12 lh18 bold"
              >
                {{ btnItem.label }}
              </span>
              <button
                class="btn secondary btn-corner"
                v-if="leftCornerbtn.label"
                @click="leftCornerbtn.labelMethod(item)"
              >
                {{ leftCornerbtn.label }}
              </button>
            </div>
            <div
              v-else-if="
                !displayEditableIconMenu && editableMenuItems?.length > 0
              "
              class="cta-lst"
            >
              <span
                v-for="(btnItem, index) in editableMenuItems"
                :key="index"
                @click="btnItem.labelMethod(item)"
              >
                {{ btnItem.label }}
              </span>
            </div>
          </div>
          <div
            class="radio-wrapper ml10"
            v-if="listType == 'savedAddresses' && radioBtnEnable"
          >
            <label class="radio">
              <input
                type="radio"
                :name="'savedAddressRadio'"
                @change="radioBtnMethod?.radioMethod(item)"
              />
              <i><span></span></i>
            </label>
          </div>
          <i
            v-if="displayEditableIconMenu"
            :class="editableIconClass"
            @click="handleIconMenuClick($event, index + ' ' + item?.address_id)"
          ></i>
        </div>
        <div
          v-if="selectedDropdownKey === index + ' ' + item?.address_id"
          class="menu-drop-down"
        >
          <ul>
            <li
              v-for="(btnItem, index) in editableMenuItems"
              :key="index + ' ' + item?.address_id"
              @click="dropdownItemClick($event, btnItem.labelMethod, item)"
              class="pd12 menu-drop-down-item"
            >
              {{ btnItem.label }}
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <!-- menu-drop-down-outerDiv this div is for closing dropdown in case clicking outside dropdown -->
    <div
      v-if="displayEditableIconMenu && selectedDropdownKey !== ''"
      class="menu-drop-down-outerDiv"
      @click.self="checkClickedOutside($event)"
      @click.stop
    ></div>
  </div>
</template>

<script>
import get from "lodash/get";
import addressIcons from "../assets/addressIcons.json";
import { staticImgBaseUrl } from "../config/apiEndpoints";
export default {
  name: "ReusableList",
  components: {
    //
  },
  props: {
    items: { type: Array, default: [] },
    onClick: { type: Function, default: () => {} },
    outsideClick: { type: Function },
    listClass: { type: String },
    mainTextKey: {
      type: String,
      default: "structuredFormatting.mainText",
    },
    subTextKey: {
      type: String,
      default: "structuredFormatting.secondaryText",
    },
    commanItemIconClass: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "search_lst",
    },
    listTitle: {
      type: String,
      default: "Recently Searched",
    },
    listTitleClass: {
      type: String,
      default: "reusable-list-title",
    },
    listItemClass: {
      type: String,
      default: "reusable-list-item",
    },
    leftCornerbtn: {
      required: false,
      default: {},
    },
    editableIconClass: {
      type: String,
      // default: "hkfi-minus",
    },
    editableMenuItems: {
      type: Array,
      // default: [
      //   { label: "Edit", labelMethod: () => {} },
      //   { label: "Delete", labelMethod: () => {} },
      // ],
    },
    displayEditableIconMenu: { type: Boolean, default: false },
    itemIconKey: {
      type: String,
      default: "",
    },
    listType: {
      type: String,
      default: "",
    },
    radioBtnMethod: {
      required: false,
    },
    radioBtnEnable: {
      required: false,
      default: false,
    },
    destination: {
      required: false,
      default: "",
    },
    listName: {
      required: false,
      default: "",
    },
    marginClass: {
      required: false,
      default: "",
    },
    titleRightButton: {
      type: String,
      default: "",
    },
    titleRightButtonClass: {
      type: String,
      default: "",
    },
    handleRightButtonClick: { type: Function, default: () => {} },
  },
  data() {
    return {
      get: get,
      selectedDropdownKey: "",
      staticImgBaseUrl,
    };
  },
  mounted() {},
  methods: {
    handleIconMenuClick(event, index) {
      this.selectedDropdownKey = index;
    },
    checkIsLocationDestination() {
      return this.destination == "location";
    },
    getIconClass(address) {
      return (
        addressIcons?.[address?.customer_address_name]?.icon ||
        addressIcons["Other"]?.icon
      );
    },
    getIconImgSrc(address) {
      return (
        addressIcons?.[address?.customer_address_name]?.iconImgSrc ||
        addressIcons["Other"]?.iconImgSrc
      );
    },
    dropdownItemClick(event, labelMethod, item) {
      this.resetSelectedDropdownKey();
      labelMethod(item);
    },
    resetSelectedDropdownKey() {
      this.selectedDropdownKey = "";
    },
    checkClickedOutside(e) {
      this.resetSelectedDropdownKey();
    },
  },
};
</script>
